import { render } from "./PracticeButton.vue?vue&type=template&id=12d9f6ab&scoped=true"
import script from "./PracticeButton.vue?vue&type=script&lang=js"
export * from "./PracticeButton.vue?vue&type=script&lang=js"

import "./PracticeButton.vue?vue&type=style&index=0&id=12d9f6ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d9f6ab"]])

export default __exports__